<template>
    <div>
        <svg
            v-if="name === 'pointer'"
            v-bind="allAttrs"
            viewBox="0 0 40 20.73"
        >
            <path
                class="cls-1"
                style="fill-rule:evenodd;"
                d="M37.87,20.37a1.25,1.25,0,0,0,1.76-1.77L21.77.73a2.51,2.51,0,0,0-3.54,0L.37,18.6a1.25,1.25,0,0,0,1.76,1.77L20,2.5Z"
                transform="translate(0 0)"
            />
        </svg>
        <svg
            v-if="name === 'close'"
            v-bind="allAttrs"
            viewBox="0 0 24 24"
        >
            <rect
                x="10.51"
                y="-3.63"
                width="2"
                height="30.35"
                transform="translate(-4.85 11.5) rotate(-45)"
            />
            <rect
                x="-3.68"
                y="10.46"
                width="30.35"
                height="2"
                transform="translate(-4.79 11.47) rotate(-45)"
            />
        </svg>
    </div>
</template>

<script>
export default {
    props: {
        hidden: { type: Boolean, default: false },
        name: {
            type: String,
            required: true,
            validator: value => ['pointer', 'close'].includes(value),
        },
        rotate: { type: [Number, String], default: 0 },
    },

    computed: {
        isPresentation () {
            return this.hidden ? undefined : 'img'
        },

        allAttrs () {
            return {
                class: ['snoop-icon', `snoop-icon--${this.name}`],
                style: `transform: rotate(${this.rotate}deg)`,
                'aria-hidden': `${this.hidden}`,
                focusable: 'false',
                role: this.isPresentation,
            }
        },
    },
}
</script>
